/**
 * Helper to extract array from API response that may have different formats.
 * Handles: direct array, { value: [...] }, { values: [...] }, or returns empty array.
 */
export function extractArrayFromResponse<T>(responseValue: unknown): T[] {
	if (Array.isArray(responseValue)) {
		return responseValue;
	}
	if (responseValue && typeof responseValue === 'object') {
		const obj = responseValue as { value?: T[]; values?: T[] };
		const extracted = obj.value ?? obj.values;
		if (Array.isArray(extracted)) {
			return extracted;
		}
	}
	return [];
}
